import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import LoadingPageText from './../common/Loading/LoadingPageText';
import ActualsSearchFilters from './ActualsSearchFilters';
import { useFetchTreatmentVisits } from '../../actions/areas/visitActuals/fetchHooks/fetchVisitActuals';
import { eventHandlers } from './visitActualsHandler';
import { tableSettings } from './visitActualsTableSettings';
import { getDateForApi } from '../../utils/dates';
import { GridFilterPages } from '../../enums/gridFilterPages';

export default function VisitActualsPage() {
  document.title = 'Visit Actuals';

  const [state, setState] = useState({
    forceReload: false,
    selectedTeams: useSelector(
      store =>
        store.global.gridFilters.items.find(item => item.key === GridFilterPages.VisitActuals).filters.selectedTeams,
    ),
    selectedClinician: useSelector(
      store =>
        store.global.gridFilters.items.find(item => item.key === GridFilterPages.VisitActuals).filters
          .selectedClinician,
    ),
    dateFrom: useSelector(
      store => store.global.gridFilters.items.find(item => item.key === GridFilterPages.VisitActuals).filters.dateFrom,
    ),
    dateTo: useSelector(
      store => store.global.gridFilters.items.find(item => item.key === GridFilterPages.VisitActuals).filters.dateTo,
    ),
    nhsNumber: useSelector(
      store => store.global.gridFilters.items.find(item => item.key === GridFilterPages.VisitActuals).filters.nhsNumber,
    ),
    currentPage: 1,
    pageSize: 15,
    sortColumn: 'Id',
    sortDirection: 'desc',
  });

  const model = {
    OrgUnitIds: state.selectedTeams.map(unit => unit.id),
    ClinicianIds: state.selectedClinician ? state.selectedClinician.id : null,
    DateFrom: getDateForApi(state.dateFrom),
    DateTo: getDateForApi(state.dateTo),
    nhsNumber: state.nhsNumber,
    pageSize: state.pageSize,
    currentPage: state.currentPage,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
  };

  const { data, isDataLoading, isTableDataLoading } = useFetchTreatmentVisits(model, state.forceReload);

  const events = eventHandlers(state, setState);
  const settings = tableSettings({
    count: data.totalCount,
    page: data.currentPage - 1,
    pageSize: data.pageSize,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
    eventHandlers: events,
    isTableDataLoading,
  });

  if (isDataLoading)
    return (
      <LoadingPageText showHeader={false}>Wait a moment while we gather Visit Actuals list info...</LoadingPageText>
    );
  return (
    <React.Fragment>
      <section className="slick-page-header-section">
        <ActualsSearchFilters onSubmit={events.onFiltersChange} events={events} />
      </section>
      <div className="page-content-wrapper">
        <MUIDataTable title={settings.name} data={data.visits} columns={settings.columns} options={settings.options} />
      </div>
    </React.Fragment>
  );
}
